import React from 'react'
import Helmet from 'react-helmet'

const WebComponentSubNavigation = (props) => {
  return (
    <>
      <Helmet>
        <script type="module" src="/static/dfb-web-components.js" />
      </Helmet>
      <dfb-sub-navigation
        src={`/navigation/mainNavigation-${props?.language || 'de'}.json`}
        root-path={props.fullSlug}
        brand={props.brand}
      ></dfb-sub-navigation>
    </>
  )
}

export default WebComponentSubNavigation
